<template>
    <div class="audio-visualfixation">
      <div class="Notenabled" v-show="!cameraActive">
        <div>
          <p class="title">摄像头未开启</p>
          <div class="openCamera" @click="openCamera">
            <span class="Cameraicon"><img src="../../../public/img/ic_open_camera@2x.png"></span>
            <p>开启摄像头</p>
          </div>
        </div>
      </div>
      <div class="unseal" v-show="cameraActive">
        <p class="RecordTime">{{secondsToHms(RecordTime)}}</p>
        <video class="video" ref="videoElement" autoplay></video>
        <div class="footer">
          <div class="item" @click="closeCamera">
            <span><img src="../../../public/img/ic_close_camera@2x.png" alt=""></span>
            <p>关闭摄像头</p>
          </div>
          <div class="item" @click="UpDateVideo">
            <span><img src="../../../public/img/ic_upload@2x.png" alt=""></span>
            <p>上传视频</p>
          </div>
          <div class="item"  @click="downloadVideo">
            <span><img src="../../../public/img/ic_download@2x.png" alt=""></span>
            <p>下载视频</p>
          </div>
          <div class="item" @click="togglepause" v-if="recording">
            <span :style="{background:pause?'#F24444':'rgba(0, 0, 0, 0.5)'}">
              <img v-if="pause" src="../../../public/img/ic_pause@2x.png" alt="">
              <img v-else src="../../../public/img/ic_continue@2x.png" alt="">
            </span>
            <p>{{ pause ? "暂停录制" : "继续录制" }}</p>
          </div>
          <div class="item" @click="toggleRecording">
            <span :style="{background:recording?'#F24444':'rgba(0, 0, 0, 0.5)'}">
              <img v-if="recording" src="../../../public/img/ic_ending@2x.png" alt="">
              <img v-else src="../../../public/img/ic_play@2x.png" alt="">
            </span>
            <p>{{ recording ? "停止录制" : "开始录制" }}</p>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        cameraActive: false,
        recording: false,
        recordedVideoUrl: "",
        recordedBlob:'',
        stream: null,
        videoElement: null,
        mediaRecorder: null,
        chunks: [],
  
        rotate: {
          x: 0,
          y: 0,
        },
        RecordTime:0,
        timer:null,
        pause:false
      };
    },
    mounted() {
      this.videoElement = this.$refs.videoElement;
      this.list();
    },
    methods: {
      // 打开摄像头
      openCamera(){
        if(navigator.mediaDevices){
          navigator.mediaDevices
            .getUserMedia({ video: true,audio:true})
            .then((stream) => {
              this.stream = stream;
              this.videoElement.srcObject = stream;
              this.cameraActive = true;
            })
            .catch((error) => {
              console.log(error)
              this.$message({
                    message: '摄像头被占用，无法调用',
                    type: 'error'
                    });
              this.stream.getTracks().forEach((track) => {
                track.stop();
              });
            });
          }else{
            alert("请开启摄像头权限，如不是https请前往https://www.cnblogs.com/tuofei13/p/16636145.html查看教程即可开启摄像头")
          }
      },
      // 关闭摄像头
      closeCamera(){
        if (this.cameraActive) {
            this.videoElement.srcObject = null;
            this.stream.getTracks().forEach((track) => {
              track.stop();
            });
            this.cameraActive = false;
        }
      },
      secondsToHms(sec) {
        var hours = Math.floor(sec / 3600);
        var minutes = Math.floor((sec - (hours * 3600)) / 60);
        var seconds = sec % 60;
      
        return [hours, minutes, seconds]
          .map(num => num < 10 ? '0' + num : num.toString())
          .filter((num, i) => i > 0 || hours > 0)
          .join(':');
      },
      toggleRecording() {
        if (!this.recording) {
          this.RecordTime=0;
          this.startRecording();
        } else {
          this.stopRecording();
        }
      },
      
      startRecording() {
        if (MediaRecorder.isTypeSupported("video/webm")) {
          this.chunks = [];
          this.mediaRecorder = new MediaRecorder(this.stream, {
            mimeType: "video/webm;codecs=h264",
          });
          this.mediaRecorder.ondataavailable = (e) => {
            if (e.data && e.data.size > 0) {
              this.chunks.push(e.data);
            }
          };
          this.mediaRecorder.onstop = () => {
            const recordedBlob = new Blob(this.chunks, { type: "video/mp4" });
            this.chunks = [];
            this.recordedBlob=recordedBlob;
            this.recordedVideoUrl = URL.createObjectURL(recordedBlob);
          };
          this.mediaRecorder.start();
          this.recording = true;
          clearInterval(this.timer);
          this.interTime();
          this.pause=true;
        } else {
          this.$message({
                    message: '不支持录制视频',
                    type: 'error'
                    });
        }
      },
      
      interTime(){
        this.timer=setInterval(() => {
          this.RecordTime+=1;
        }, 1000);
      },
      stopRecording() {
        if (this.recording) {
          clearInterval(this.timer);
          this.mediaRecorder.stop();
          this.mediaRecorder = null;
          this.recording = false;
          this.pause=false;
        }
      },
      // 暂停和继续录制
      togglepause(){
        if(!this.pause){//继续录制
          this.pause=true;
          this.mediaRecorder.resume();
          clearInterval(this.timer);
          this.interTime();
        }else{//暂停录制
          this.pause=false;
          clearInterval(this.timer);
          this.mediaRecorder.pause();
        }
      },
      downloadVideo() {
        if(this.recording){
          this.$message({
                    message: '请先结束录制',
                    type: 'error'
                    });
          return false;
        }
        if (this.recordedVideoUrl) {
          const a = document.createElement("a");
          a.href = this.recordedVideoUrl;
          a.download = "recorded_video.mp4";
          a.click();
        }
      },
    //   上传视频
      UpDateVideo(){
        if(this.recordedBlob=='' || this.recording){
          this.$message({ message: '请先完成视频录制',type: 'error'});
          return false;
        }
        let formdata = new FormData();
        formdata.append('remark', "");
        formdata.append('movingFile', this.recordedBlob);
        this.$Http_Post('/basic/transcribe/add',formdata).then(res=>{
            if(res.Code==0){
                this.$message({type: 'success', message:res.Message});
            }else{
                this.$message({type: 'error', message:res.Message});
            }
        })
      },
      // 录音文件列表
      list(){
        this.$Http_Post('/basic/transcribe/list').then(res=>{
          if(res.Code==0){
            this.recordedVideoUrl=res.Data[1].materialUrl
          }else{
            this.$message({type: 'error', message:res.Message});
          }
        })
      }
    },
    destroyed() {
        this.closeCamera();
    },
  };
  </script>
<style>
.el-main{position: relative;}
.audio-visualfixation .Notenabled{background: #000;position: absolute;top: 0;left: 0;width: 100%;height:100%;display: flex;align-items: center;justify-content: center;color: #fff;}
.audio-visualfixation .Notenabled .title{text-align: center;padding-bottom:10px;}
.audio-visualfixation .openCamera{border: 1px solid #fff;border-radius: 200px;display: flex;padding: 5px 20px;cursor: pointer;align-items: center;}
.audio-visualfixation .openCamera .Cameraicon{width: 22px;display: inline-block;padding-right: 5px;}
.audio-visualfixation img{width: 100%;display: block;}
.audio-visualfixation .openCamera p{display: inline-block;line-height: 28px;}
.audio-visualfixation .unseal{position: absolute;top: 0;left: 0;width: 100%;height:100%;}
.audio-visualfixation .unseal .RecordTime{position: absolute;top: 20px;left: 50%;transform: translate(-50%);z-index: 2;color: #fff;}
.audio-visualfixation .unseal .video{position: absolute;top: 0;left: 0;width: 100%;height: 100%;}
.audio-visualfixation .unseal .footer{position: absolute;bottom: 0;left: 0;width: 100%;text-align: center;display: flex;justify-content: center;}
.audio-visualfixation .unseal .footer .item{padding: 20px;cursor: pointer;color: #fff;}
.audio-visualfixation .unseal .footer .item:hover span{background:rgba(0, 0, 0, 0.25) !important;;}
.audio-visualfixation .unseal .footer .item span{width: 28px;display: inline-block;background: rgba(0, 0, 0, 0.5);border-radius: 50%;padding: 5px;}
</style>
  
  